<template>
  <div class="living_room">
    <div v-if="showEntry && entryType === 'type1'">
      <div class="answer_title">直播答疑</div>
      <div class="living_card_wrap" @click="toLink">
        <div class="living_card flex-row flex-al-center">
          <img class="icon" :src="imgSrc[status]" />
        </div>
      </div>
    </div>
    <div v-if="showEntry && entryType === 'type2'">
      <div
        v-if="status && status !== 'yijieda'"
        class="living_type2 flex-row flex-al-center flex-jc-bt"
        @click="toLink"
      >
        <span>仍有疑问？直播答疑专业教师为您解答</span>
        <div class="but flex-center">{{ type2Text[status] }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMyQuestionList } from '@/api/livingRoom'
import { matchLivingRoom } from '@/api/explain'
import { mapState } from 'vuex'
import { Dialog } from 'vant'
import { adModel } from '../../../../../../../library'
import { get } from 'lodash'
export default {
  props: {
    entryType: {
      type: String,
      default: 'type1'
    },
    checkSv: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {
      matchRoom: false,
      hasQuestion: false,
      quesHasSoluted: false,
      hasViewRecord: false,
      imgSrc: {
        weijieda: 'https://img01.yzcdn.cn/upload_files/2021/02/21/FhDm297R1u7pce638M2WGFF6fD9k.png',
        yijieda: 'https://img01.yzcdn.cn/upload_files/2021/02/21/FmvKNljRUOEwPHh5Z3U8rI_5DZxF.png',
        weitiwen: 'https://img01.yzcdn.cn/upload_files/2021/02/21/Ft6fjtoZ5rxFWfP1AakriQ-j-oKx.png'
      },
      type2Text: {
        weitiwen: '提问此题目',
        weijieda: '已提问，去直播间'
      },
      status: '',
      question: {}
    }
  },
  computed: {
    ...mapState('answerExplain', ['allExplains', 'hasViewExplainRight', 'hasViewVideoExplain']),
    explains() {
      return this.allExplains || []
    },
    hasExplain() {
      return this.explains.length > 0
    },
    showEntry() {
      const { hasExplain, matchRoom, hasQuestion, hasViewExplainRight, hasViewVideoExplain } = this
      // 无讲解，无匹配,无提问不展示
      console.log('直播间权限', {
        hasExplain,
        matchRoom,
        hasQuestion,
        hasViewExplainRight,
        hasViewVideoExplain
      })
      if (!this.hasExplain) {
        if (!this.matchRoom && !this.hasQuestion) {
          return false
        }
        return true
      } else {
        // 有讲解，有提问时展示
        if (this.hasQuestion) {
          return true
        }
        // 无提问，有匹配直播间，只有sv展示
        if (
          !this.hasQuestion &&
          this.matchRoom &&
          this.hasViewExplainRight &&
          this.hasViewVideoExplain
        ) {
          return true
        }
        return false
      }
    }
  },
  mounted() {
    // this.ininState()
  },
  methods: {
    async ininState() {
      const { openid, appid } = this.$store.state.user
      const { questionId, workbookId } = this.$route.query
      // 已提问列表
      const [res] = await Promise.all([
        getMyQuestionList({
          search_EQ_openid: openid,
          search_EQ_appid: appid,
          search_EQ_sourceId: questionId,
          search_NEQ_solutionState: -1
        })
      ])
      // 留下已解答或者直播未结束的question
      const question = (res.data.data.content || []).filter(
        (i) => Number(i.solutionState) === 3 || Number(i.liveStatus) !== -1
      )[0]
      // 是否已经提问
      const hasQuestion = !!question
      // 提问是否已解答/已打回
      const quesHasSoluted = hasQuestion && [3].includes(question.solutionState)
      let matchRoom = false
      // 匹配直播间
      // 获取书籍信息
      if (!hasQuestion) {
        const bookInfo = await this.$dispatch('answerRight/getBookContent', {
          workbookId
        })
        const matchRes = await matchLivingRoom({
          'search_IN_gradeList.liveroomGradePK.gradeId': bookInfo.grades.join(','),
          'search_IN_courseList.liveroomCoursePK.courseId': bookInfo.course,
          'search_IN_versionList.liveroomVersionPK.versionId': bookInfo.version
        })
        matchRoom = matchRes.data.data[0]
        if (matchRoom) {
          matchRoom.liveroomId = matchRoom.id
        }
      }
      this.question = question
      this.matchRoom = question || matchRoom
      this.hasQuestion = hasQuestion
      this.quesHasSoluted = quesHasSoluted

      if (hasQuestion && !quesHasSoluted) {
        this.status = 'weijieda'
      } else if (hasQuestion && quesHasSoluted) {
        this.status = 'yijieda'
      } else if (matchRoom) {
        this.status = 'weitiwen'
      }
    },
    setHasViewVideoExplain(value) {
      this.hasViewVideoExplain = value
    },
    toLink() {
      const { questionId } = this.$route.query
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'funcTracker', 'click', `讲解页直播入口`])
      }
      // 去提问
      if (this.status === 'weitiwen') {
        // sv 才可以提问
        if (this.hasViewExplainRight) {
          window.location.href = `/cms/webapp/home/livingRoom/index.html?room_id=${this.matchRoom.liveroomId}&comeFrom=kjj#/index?questionId=${questionId}`
        } else {
          this.svModal()
        }
      }
      // 提问未解答,去看直播
      if (this.status === 'weijieda') {
        window.location.href = `/cms/webapp/home/livingRoom/index.html?room_id=${this.matchRoom.liveroomId}&comeFrom=kjj#/index`
      }
      // 提问已解答,去个人中心提问列表
      if (this.status === 'yijieda') {
        window.location.href = `/cms/webapp/home/user/userCenter.html#/living_question_detail/${this.question.id}`
      }
    },
    svModal() {
      const tj = () => {
        this.$trackevent({
          type: 'funcTracker',
          action: 'click',
          opt_label: '讲解页——直播入口弹窗'
        })
      }
      this.$store
        .dispatch('mopaAd/getAd', {
          code: 'explainPage', // 页面
          cCodes: 'living_entry', // 页面位置
          vipLevel: get(this, '$store.state.user.userInfo.vipLevel', 'nv').toUpperCase(),
          equipment: this.$env.isIos
        })
        .then((res) => {
          if (res[0]) {
            const adItem = res[0]
            adModel({
              img: adItem.imgPath,
              link: adItem.urlPath,
              ad: adItem.externalOrg,
              click: () => {
                tj()
              }
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: '此功能为SVIP专享功能，开通后即可提问',
              confirmButtonText: '确认开通',
              showCancelButton: true
            }).then(() => {
              tj()
              // on close
              window.location.href =
                '/cms/webapp/home/vipPay/index.html?channel=svip_daanye_zbtw_gn'
            })
          }
        })
    }
  }
}
</script>
<style lang="scss">
.living_room {
  .answer_title {
    padding: 0 16px;
    margin: 15px 0;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
  }
  .living_card_wrap {
    padding: 0 16px;
    .living_card {
      img {
        width: 100%;
      }
    }
  }
  .living_type2 {
    padding: 17px 12px;
    border-bottom: 1px solid #f5f5f5;
    & > span {
      font-weight: 500;
      font-size: 12px;
      line-height: 12px;
      color: #343434;
    }
    .but {
      padding: 5px;
      height: 24px;
      background: #ff2638;
      border-radius: 17px;
      font-size: 12px;
      line-height: 12px;
      color: #ffffff;
    }
  }
}
</style>
